export enum GlobalSearchType {
  PAGE = 'page',
  BAR = 'bar',
}
